import { useEffect } from 'react';

/**
 * Custom hook to handle scroll detection and margin adjustment for MultiSelect dropdowns
 * Automatically detects when dropdown panels have scroll and adjusts margin-right accordingly
 */
export const useMultiSelectScroll = () => {
  useEffect(() => {
    // Function to check scroll and adjust margin
    const checkScrollAndAdjustMargin = () => {
      const dropdownPanels = document.querySelectorAll('.keduall-form.dropdown-input-panel .p-multiselect-items-wrapper');
      
      dropdownPanels.forEach(wrapper => {
        if (wrapper.scrollHeight > wrapper.clientHeight) {
          // Has scroll - add class
          wrapper.classList.add('has-scroll');
        } else {
          // No scroll - remove class
          wrapper.classList.remove('has-scroll');
        }
      });
    };

    // Check on mount
    checkScrollAndAdjustMargin();

    // Add event listener for window resize
    const handleResize = () => {
      setTimeout(checkScrollAndAdjustMargin, 100); // Small delay to ensure DOM is updated
    };

    window.addEventListener('resize', handleResize);

    // Add mutation observer to watch for dropdown panel changes
    const observer = new MutationObserver(() => {
      checkScrollAndAdjustMargin();
    });

    // Observe the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Add event listeners for dropdown show/hide events
    const handleDropdownShow = () => {
      setTimeout(checkScrollAndAdjustMargin, 50); // Small delay to ensure panel is rendered
    };

    // Listen for PrimeReact dropdown events
    document.addEventListener('p-multiselect-show', handleDropdownShow);
    document.addEventListener('p-dropdown-show', handleDropdownShow);

    return () => {
      window.removeEventListener('resize', handleResize);
      observer.disconnect();
      document.removeEventListener('p-multiselect-show', handleDropdownShow);
      document.removeEventListener('p-dropdown-show', handleDropdownShow);
    };
  }, []);
};

/**
 * Function to manually trigger scroll check (can be called from components)
 */
export const triggerScrollCheck = () => {
  const dropdownPanels = document.querySelectorAll('.keduall-form.dropdown-input-panel .p-multiselect-items-wrapper');
  
  dropdownPanels.forEach(wrapper => {
    if (wrapper.scrollHeight > wrapper.clientHeight) {
      wrapper.classList.add('has-scroll');
    } else {
      wrapper.classList.remove('has-scroll');
    }
  });
}; 